<template>
  <section class="affiliates">
    <div class="content padded">
      <h2 class="align-center">Affiliates</h2>
      <div class="affiliate-logos">
        <div class="logo align-right">
          <a href="http://www.tristatetruckcenter.com/" target="_blank">
            <img src="../assets/img/TSTC-Logo.png"/>
          </a>
        </div>
        <div class="logo align-left">
          <a href="https://www.mctrucks.com/" target="_blank">
            <img src="../assets/img/McDevitt-Logo.png"/>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name:'Affiliates',
    data(){
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Affiliates.vue